import { render, staticRenderFns } from "./ProjectWorkerTable.vue?vue&type=template&id=aa68c4d2&"
import script from "./ProjectWorkerTable.vue?vue&type=script&lang=ts&"
export * from "./ProjectWorkerTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports